"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var dayjs = require("dayjs");
var _require = require("../../utils/errors"),
  ThrottledNetworkError = _require.ThrottledNetworkError;
var IStrategy = require("./IStrategy");
var DROP = "DROP";
var DropStrategy = /*#__PURE__*/function (_IStrategy) {
  function DropStrategy(config) {
    var _this;
    (0, _classCallCheck2["default"])(this, DropStrategy);
    _this = _callSuper(this, DropStrategy);
    (0, _defineProperty2["default"])(_this, "key", DROP);
    (0, _defineProperty2["default"])(_this, "_config", null);
    (0, _defineProperty2["default"])(_this, "_requests", null);
    _this._config = config;
    _this._requests = {};
    return _this;
  }
  (0, _inherits2["default"])(DropStrategy, _IStrategy);
  return (0, _createClass2["default"])(DropStrategy, [{
    key: "run",
    value: function run(url, overrides) {
      var _overrides$throttle, _overrides$throttle$t, _overrides$throttle2, _overrides$throttle$m, _overrides$throttle3;
      if (overrides !== null && overrides !== void 0 && (_overrides$throttle = overrides.throttle) !== null && _overrides$throttle !== void 0 && _overrides$throttle.disabled) {
        return Promise.resolve();
      }
      var previousRecord = this._requests[url];
      var timeDiff = previousRecord ? dayjs().diff(dayjs(previousRecord.time), "seconds") : Number.MAX_SAFE_INTEGER;
      var timeThresholdForThrottling = (_overrides$throttle$t = overrides === null || overrides === void 0 || (_overrides$throttle2 = overrides.throttle) === null || _overrides$throttle2 === void 0 ? void 0 : _overrides$throttle2.thresholdSeconds) !== null && _overrides$throttle$t !== void 0 ? _overrides$throttle$t : this._config.get("network.throttle.thresholdInSeconds");
      var maxCalls = (_overrides$throttle$m = overrides === null || overrides === void 0 || (_overrides$throttle3 = overrides.throttle) === null || _overrides$throttle3 === void 0 ? void 0 : _overrides$throttle3.maxCalls) !== null && _overrides$throttle$m !== void 0 ? _overrides$throttle$m : this._config.get("network.throttle.maxCalls");
      var calls = 1;
      if (previousRecord && timeDiff < timeThresholdForThrottling) {
        if (previousRecord.calls + 1 > maxCalls) {
          return Promise.reject(new ThrottledNetworkError("Endpoint called too many times"));
        }
        calls += previousRecord.calls;
      }
      this._requests[url] = {
        time: dayjs().toISOString(),
        calls: calls
      };
      return Promise.resolve();
    }
  }], [{
    key: "build",
    value: function build(config) {
      return new DropStrategy(config);
    }
  }]);
}(IStrategy);
exports = module.exports = DropStrategy;
module.exports.DROP = DROP;